import "./Robotaxi.module.css";
import Header from "@/reusable_sections/Header";
import DiscoverItalianBrewingArt from "./sections/DiscoverItalianBrewingArt";
import Funktioner from "./sections/Funktioner";
import ContactForm from "./sections/ContactForm";
import Footer from "@/reusable_sections/Footer";
export default function RobotaxiPage() {
  return <div>
      <Header />
      <DiscoverItalianBrewingArt />
      <Funktioner />
      <ContactForm />
      <Footer />
    </div>;
}